import axios, { Axios, AxiosRequestConfig } from 'axios';
import { FileResponse } from '~/app-modules/core/clients/dto/file-response';
import { ConfigProvider } from '~/app-modules/core/ioc/config.provider';

@singleton()
export class HttpConnection {
  constructor(protected configProvider: ConfigProvider) {
    this.http = axios.create({
      baseURL: configProvider.getPublicRuntimeConfig().app.apiUrl,
    });
  }

  private http: Axios;

  async executeRequest(options: AxiosRequestConfig): Promise<{ [key: string]: any }> {
    const _result = await this.http.request(options);
    return _result.data;
  }

  async downloadFile(options: AxiosRequestConfig): Promise<FileResponse> {
    const result = await this.http.request(options);

    const cd = result.headers?.['content-disposition'] ?? result.headers?.['Content-Disposition'];
    let fileName: string | null = null;

    if (cd) {
      const fileNameAttribute = cd
        .split(';')
        .map((s) => s.trim())
        .find((s) => s.toLowerCase().startsWith('filename'));

      if (fileNameAttribute) {
        // Сервер опционально заключает имя файла в двойные кавычки (например, если в имени есть пробел)
        const fileNameMatch = fileNameAttribute.match(/filename="?([^"]+)"?/);
        if (fileNameMatch?.[1]) fileName = fileNameMatch[1];
      }
    }

    return {
      blob: result.data,
      fileNameWithExtension: fileName,
    } as FileResponse;
  }
}

export class RequestRetryLimitExceededException extends Error {
  message = 'Request Retry limit was exceeded';
}
